import React, { useState } from "react";
import { ModalTask } from "./ModalTask";

export const BtnGiaoViec = ({ item, onReload, disabled }) => {
    const [show, setShow] = useState(false);
    const handleShow = () => {
        setShow(true);
    };
    return (
        <>
            <a type="button" className="popover-basic"  onClick={handleShow} disabled={disabled} title="Giao việc">
                <img src="/app-assets/images/icon-cho-thue-v2.png" alt="Giao việc" />
            </a> 
            {show && <ModalTask mode="reassign" item={item} show={show} onHide={() => setShow(false)} onSaved={() => { setShow(false); onReload(); }} />}
        </>
    );
};
 